import { reportService } from '@/core';
import { ref } from 'vue';

/**
 * @param {function} entryCall Make http call
 * @param {function|null} successCall Success callback
 * @param {function|null} errorCall Error callback
 */
export function useHttpAdapter(entryCall, successCall = null, errorCall = null) {
  const busy = ref(false);
  const loaded = ref(false);
  const executing = ref(false);

  function cancel() {
    if (executing.value) {
      entryCall().abort.abort();
      reset();
    }

    return this;
  }

  function execute(passive = false) {
    if (executing.value) {
      return null;
    }

    if (!passive) {
      busy.value = true;
    }

    executing.value = true;

    return entryCall()
      .then(result => {
        reset();

        if (successCall) {
          successCall(result);
        }

        loaded.value = true;

        return result;
      })
      .catch(e => {
        reportService.report(e);

        loaded.value = true;
        reset();

        try {
          if (errorCall) {
            errorCall(e);
          }
        } catch (listenerError) {
          reportService.report(listenerError);
        }

        return e;
      });
  }

  const reset = () => {
    busy.value = false;
    executing.value = false;
  };

  return {
    cancel,
    execute,
    busy,
    loaded,
  };
}
